<template>
  <v-app v-if="articleInfoValue">
    <v-container fluid class="article-actions">
      <v-row>
        <v-col cols="2">
          <v-subheader>نام</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="نام" v-model="firstName"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>نام خانوادگی</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            placeholder="نام خانوادگی"
            v-model="lastName"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>نام کاربری</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            placeholder="کد ملی"
            v-model="username"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>ایمیل</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="شماره تماس" v-model="email"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>وضعیت</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-switch
            v-model="status"
          ></v-switch>
        </v-col>
      </v-row>

      <v-row justify="center mb-3">
        <v-btn
          class="ml-4 white--text font-weight-bold indigo darken-4 white--text"
          @click="editHandler"
        >
          ثبت کردن
        </v-btn>
        <router-link to="/access-license/users">
          <v-btn class="white--text font-weight-bold indigo lighten-2">
            انصراف
          </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import baseURL from "@/axios";
export default {
  created() {
    axios
      .get(`${baseURL}User/GetById?id=${this.$route.params.id}`)
      .then((res) => {
        this.firstName = res.data.data.firstName;
        this.lastName = res.data.data.lastName;
        this.email = res.data.data.email;
        this.username = res.data.data.username;
        this.status = res.data.data.status;
        this.lastLogin = res.data.data.lastLogin;
        this.registerDate = res.data.data.registerDate;
      });
    axios.get(`${baseURL}User/GetAll`).then((res) => {
      res.data.data.map((item) => {
        this.states.push({
          text: item.title,
          value: item.id,
        });
      });
    });
  },

  data() {
    return {
      id: this.$route.params.id,
      firstName: "",
      lastName: "",
      username: "",
      status: null,
      lastLogin: "",
      registerDate: "",
      email: "",
      state: {
        value: null,
        text: null,
      },
      states: [],
      city: {
        value: null,
        text: null,
      },
      cities: [],
      selectItem: "null",
    };
  },
  computed: {
    ...mapGetters(["tokenValue", "articleInfoValue", "itemList"]),
  },
  methods: {
    onFileSelected(event) {
      this.image = event.target.files[0];
    },
    async editHandler() {
      //   this.list.map((item) => {
      //     if (item.title == this.selectItem) {
      //       this.selectItem = item.id;
      //     }
      //   });
      await axios
        .put(
          `${baseURL}User/Edit`,
          {
            id: this.id,
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            username: this.username,
            status: this.status,
            lastLogin: this.lastLogin,
            registerDate: this.registerDate,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then(() => {
          this.$router.push("/access-lisence/users");
        });
    },
    async changeHandler() {
      await axios
        .get(`${baseURL}GeoDivision/GetById?id=${this.state}`)
        .then((res) => {
          res.data.data.children.map((item) => {
            this.cities.push({
              text: item.title,
              value: item.id,
            });
          });
        });
    },
  },
};
</script>

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
</style>